"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var Tooltip_1 = __importDefault(require("../Tooltip"));
var Text_1 = __importDefault(require("../Text"));
var variables_1 = require("../../style/variables");
var layout_1 = require("../layout");
var styles = {
    overlay: {
        maxWidth: 320,
    },
    overlayInner: {
        padding: "var(" + variables_1.Spacing.sp12 + ")",
        backgroundColor: "var(" + variables_1.RootColor.Gray.DARK_4 + ")",
        maxHeight: 500,
        overflow: 'overlay',
    },
};
var Popover = function (_a) {
    var title = _a.title, body = _a.body, secondaryTitle = _a.secondaryTitle, secondaryBody = _a.secondaryBody, _b = _a.trigger, trigger = _b === void 0 ? 'click' : _b, props = __rest(_a, ["title", "body", "secondaryTitle", "secondaryBody", "trigger"]);
    var overlay = react_2.useMemo(function () { return (react_1.jsx(layout_1.Flex, { gap: "var(" + variables_1.Spacing.sp12 + ")", direction: "column" },
        react_1.jsx(layout_1.Flex, { gap: "var(" + variables_1.Spacing.sp4 + ")", direction: "column" },
            react_1.jsx(Text_1.default.Body, { size: "sm", weight: "semibold", color: "var(" + variables_1.RootColor.White + ")" }, title),
            body ? (react_1.jsx(Text_1.default.Body, { size: "sm", color: "var(" + variables_1.RootColor.White + ")" }, body)) : null),
        secondaryTitle || secondaryBody ? (react_1.jsx(layout_1.Flex, { gap: "var(" + variables_1.Spacing.sp4 + ")", direction: "column" },
            secondaryTitle && (react_1.jsx(Text_1.default.Title, { size: "sm", color: "var(" + variables_1.TextColor.SECONDARY + ")" }, secondaryTitle)),
            secondaryBody && (react_1.jsx(Text_1.default.Body, { size: "sm", color: "var(" + variables_1.RootColor.White + ")" }, secondaryBody)))) : null)); }, [title, body, secondaryTitle, secondaryBody]);
    return (react_1.jsx(Tooltip_1.default, __assign({ overlay: overlay, overlayStyle: styles.overlay, overlayInnerStyle: styles.overlayInner, trigger: trigger }, props)));
};
exports.default = Popover;
